var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 146,
    viewBox: "0 0 220 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_35519)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5999 31.8125C46.5999 30.7079 47.4953 29.8125 48.5999 29.8125L172.431 29.8125V82.8554C172.431 83.6535 172.905 84.3752 173.638 84.6915L246.975 116.355C247.708 116.672 248.182 117.393 248.182 118.191V145.967H165.316L47.7191 88.284C47.034 87.948 46.5999 87.2515 46.5999 86.4884V31.8125Z",
    fill: "url(#paint0_linear_2622_35519)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.23 0.957031L45.9865 19.4398V86.9701L99.6166 68.4873L100.23 0.957031Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.01 0.957031L171.946 17.598V85.1283L100.01 68.4873V0.957031Z",
    fill: "#ABABAB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2622_35519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7816 4.20421C97.7816 4.20421 113.618 10.8226 113.682 16.0564C113.739 20.7376 101.778 26.8322 98.0243 24.0342C93.8278 20.9061 97.7816 4.20421 97.7816 4.20421Z",
    fill: "url(#paint1_linear_2622_35519)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.079 8.71399C100.079 8.71399 108.255 12.1308 108.288 14.8328C108.318 17.2495 102.143 20.3958 100.205 18.9514C98.0382 17.3364 100.079 8.71399 100.079 8.71399Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.08 4.20421C137.08 4.20421 121.244 10.8226 121.18 16.0564C121.123 20.7376 133.084 26.8322 136.838 24.0342C141.034 20.9061 137.08 4.20421 137.08 4.20421Z",
    fill: "url(#paint2_linear_2622_35519)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.93 8.71399C134.93 8.71399 126.755 12.1308 126.722 14.8328C126.692 17.2495 132.867 20.3958 134.805 18.9514C136.972 17.3364 134.93 8.71399 134.93 8.71399Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.673,
    cy: 31.3976,
    rx: 26.1935,
    ry: 18.6554,
    fill: "url(#paint3_linear_2622_35519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.124 19.1543C110.192 18.5121 110.378 16.7441 110.378 16.7441",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.352 19.358C107.282 18.9157 106.966 16.9201 106.966 16.9201",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.824 19.166C124.756 18.5238 124.57 16.7558 124.57 16.7558",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.596 19.3697C127.666 18.9274 127.982 16.9318 127.982 16.9318",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.941 10.1055C113.713 11.5893 110.943 13.9424 110.943 13.9424C110.943 13.9424 115.458 16.6372 115.545 14.2911C115.552 14.0943 115.567 13.9091 115.589 13.7342C116.658 14.7542 118.311 15.9915 118.866 14.5539C119.598 12.6596 120.673 12.1852 121.906 11.6416C122.099 11.5568 122.295 11.4703 122.494 11.3764C119.741 11.3927 117.402 11.8984 116.007 12.286C116.367 11.5704 116.898 11.0786 117.472 10.5477C117.626 10.4048 117.783 10.2591 117.941 10.1055Z",
    fill: "url(#paint4_linear_2622_35519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5704 22.707C97.5704 22.707 94.4436 24.5601 91.6642 28.0744C91.8609 27.9751 92.0499 27.8738 92.2352 27.7744C93.0604 27.3318 93.8127 26.9284 94.8473 26.9215C93.6799 27.7928 91.8884 29.3028 90.2219 31.41C90.4185 31.3108 90.6075 31.2094 90.7928 31.1101C91.6409 30.6552 92.4121 30.2416 93.4919 30.2575C91.9605 31.5516 90.3899 33.5083 89.9888 36.2572C91.5997 34.0408 92.7364 33.1744 96.2698 33.3524C99.8031 33.5303 96.7949 28.2193 96.7949 28.2193C96.7949 28.2193 96.6438 28.2771 96.3864 28.3975C96.3833 27.9619 96.3461 27.5218 96.301 27.1419C96.3343 27.1515 96.3679 27.1614 96.4018 27.1717C98.6484 27.8535 97.5704 22.707 97.5704 22.707Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3763 33.4109C92.3763 33.4109 90.3783 36.4471 89.4208 40.8242C90.4078 39.5246 90.9651 38.308 93.2832 37.936C95.6013 37.5639 92.3763 33.4109 92.3763 33.4109Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5411 37.0398C92.5411 37.0398 90.5431 40.076 89.5856 44.4531C90.5726 43.1535 91.1299 41.9369 93.448 41.5649C95.7661 41.1928 92.5411 37.0398 92.5411 37.0398Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0949 38.7044C94.0949 38.7044 89.7331 43.3714 91.5012 48.9124C91.9775 46.2141 92.6194 44.9371 95.8731 43.5481C99.1269 42.1591 94.0949 38.7044 94.0949 38.7044Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.212 35.0995C100.212 35.0995 99.8098 38.7119 100.944 43.0466C101.233 41.4405 101.178 40.1035 103.074 38.7197C104.971 37.3358 100.212 35.0995 100.212 35.0995Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.008 38.2597C102.008 38.2597 101.606 41.872 102.74 46.2067C103.029 44.6007 102.973 43.2637 104.87 41.8798C106.766 40.496 102.008 38.2597 102.008 38.2597Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.148 39.0373C104.148 39.0373 102.38 45.1759 106.471 49.3103C105.671 46.6899 105.663 45.2606 107.931 42.5459C110.2 39.8311 104.148 39.0373 104.148 39.0373Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.242 44.4365C105.242 44.4365 106.642 47.7907 109.735 51.0321C109.21 49.4872 108.513 48.3448 109.5 46.215C110.488 44.0852 105.242 44.4365 105.242 44.4365Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.346 46.3271C108.346 46.3271 109.746 49.6813 112.839 52.9228C112.314 51.3778 111.617 50.2354 112.604 48.1056C113.592 45.9758 108.346 46.3271 108.346 46.3271Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.595 45.971C110.595 45.971 112.025 52.1968 117.607 53.8295C115.637 51.9258 114.937 50.6796 115.605 47.2054C116.273 43.7312 110.595 45.971 110.595 45.971Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.444 22.707C137.444 22.707 140.57 24.5601 143.35 28.0744C143.153 27.9751 142.964 27.8738 142.779 27.7744C141.953 27.3318 141.201 26.9283 140.166 26.9215C141.334 27.7928 143.125 29.3028 144.792 31.4102C144.595 31.3109 144.406 31.2096 144.221 31.1102C143.373 30.6553 142.602 30.2418 141.522 30.2577C143.054 31.5518 144.624 33.5084 145.025 36.2572C143.414 34.0409 142.278 33.1745 138.744 33.3524C135.211 33.5303 138.219 28.2193 138.219 28.2193C138.219 28.2193 138.37 28.2771 138.628 28.3975C138.631 27.9619 138.668 27.5218 138.713 27.1419C138.68 27.1515 138.646 27.1614 138.612 27.1717C136.366 27.8535 137.444 22.707 137.444 22.707Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.636 33.4109C142.636 33.4109 144.634 36.4471 145.592 40.8242C144.605 39.5246 144.047 38.308 141.729 37.936C139.411 37.5639 142.636 33.4109 142.636 33.4109Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.471 37.0398C142.471 37.0398 144.469 40.076 145.427 44.4531C144.44 43.1535 143.883 41.9369 141.564 41.5649C139.246 41.1928 142.471 37.0398 142.471 37.0398Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.918 38.7044C140.918 38.7044 145.279 43.3714 143.511 48.9124C143.035 46.2141 142.393 44.9371 139.139 43.5481C135.886 42.1591 140.918 38.7044 140.918 38.7044Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.007 35.0995C137.007 35.0995 137.408 38.7119 136.274 43.0466C135.985 41.4405 136.041 40.1035 134.144 38.7197C132.248 37.3358 137.007 35.0995 137.007 35.0995Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.211 38.2597C135.211 38.2597 135.613 41.872 134.479 46.2067C134.189 44.6007 134.245 43.2637 132.348 41.8798C130.452 40.496 135.211 38.2597 135.211 38.2597Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.07 39.0373C133.07 39.0373 134.838 45.1759 130.747 49.3103C131.547 46.6899 131.555 45.2606 129.287 42.5459C127.018 39.8311 133.07 39.0373 133.07 39.0373Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.976 44.4325C131.976 44.4325 130.576 47.7868 127.483 51.0282C128.008 49.4832 128.705 48.3409 127.718 46.2111C126.73 44.0813 131.976 44.4325 131.976 44.4325Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.872 46.3232C128.872 46.3232 127.472 49.6774 124.379 52.9189C124.904 51.3739 125.601 50.2315 124.614 48.1017C123.626 45.9719 128.872 46.3232 128.872 46.3232Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.623 45.9671C126.623 45.9671 125.193 52.1929 119.611 53.8256C121.581 51.9219 122.281 50.6757 121.613 47.2015C120.945 43.7273 126.623 45.9671 126.623 45.9671Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37 26.2457C131.37 29.2723 128.895 31.7258 125.843 31.7258C122.79 31.7258 120.316 29.2723 120.316 26.2457C120.316 23.2191 122.79 20.7656 125.843 20.7656C128.895 20.7656 131.37 23.2191 131.37 26.2457Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.551 26.2467C129.551 28.2772 127.891 29.9232 125.843 29.9232C123.795 29.9232 122.135 28.2772 122.135 26.2467C122.135 24.2163 123.795 22.5703 125.843 22.5703C127.891 22.5703 129.551 24.2163 129.551 26.2467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.161 27.409C124.561 25.5562 127.416 25.5254 127.934 27.409",
    stroke: "#767676",
    strokeWidth: 1.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.029 26.2457C115.029 29.2723 112.554 31.7258 109.502 31.7258C106.449 31.7258 103.975 29.2723 103.975 26.2457C103.975 23.2191 106.449 20.7656 109.502 20.7656C112.554 20.7656 115.029 23.2191 115.029 26.2457Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21 26.2467C113.21 28.2772 111.549 29.9232 109.502 29.9232C107.454 29.9232 105.794 28.2772 105.794 26.2467C105.794 24.2163 107.454 22.5703 109.502 22.5703C111.549 22.5703 113.21 24.2163 113.21 26.2467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82 27.409C108.22 25.5562 111.074 25.5254 111.593 27.409",
    stroke: "#767676",
    strokeWidth: 1.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.865,
    cy: 33.3353,
    rx: 1.53074,
    ry: 1.3314,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.53074,
    cy: 1.3314,
    rx: 1.53074,
    ry: 1.3314,
    transform: "matrix(-1 0 0 1 121.124 32.0039)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.142 33.8029C120.291 35.007 117.694 34.6338 117.809 32.1641",
    stroke: "#767676",
    strokeWidth: 1.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.346 33.8029C115.198 35.007 117.794 34.6338 117.679 32.1641",
    stroke: "#767676",
    strokeWidth: 1.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.375 32.0125H118.982",
    stroke: "#767676",
    strokeWidth: 1.404,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.953 34.2109C108.409 34.2109 101.441 34.2109 101.441 34.2109",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.848 36.0639C108.934 36.258 104.813 37.1341 104.813 37.1341",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.873 34.2109C127.417 34.2109 134.385 34.2109 134.385 34.2109",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.978 36.0639C126.892 36.258 131.013 37.1341 131.013 37.1341",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9856 19.375L117.922 36.016V106.616L45.9856 86.9053V19.375Z",
    fill: "url(#paint5_linear_2622_35519)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2108 77.036L57.3564 75.1873V73.1476L62.3199 60.5018L65.9666 59.1719L60.8005 73.7304L64.2108 74.3075V68.5378L67.6548 68.3886V74.8902L69.3093 75.1702V78.4111L67.6548 77.9649V81.3598L64.2108 80.0487V77.036Z",
    fill: "url(#paint6_linear_2622_35519)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9757 86.3848L91.1213 84.7232V82.5619L96.0848 69.4531L99.7315 68.2578L94.5654 83.0857L97.9757 83.6043V77.7249L101.42 77.5909V84.1281L103.074 84.3798V87.6207L101.42 87.2197V90.6332L97.9757 89.4548V86.3848Z",
    fill: "url(#paint7_linear_2622_35519)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.766 68.3181C75.8084 67.5883 75.9866 66.9338 76.3006 66.3522C76.6146 65.767 77.0194 65.2552 77.515 64.8165C78.0106 64.3738 78.5737 64.0218 79.2043 63.7614C79.8348 63.4987 80.4873 63.3435 81.1617 63.2981C81.836 63.2532 82.4761 63.3248 83.0819 63.5149C83.6878 63.708 84.2149 64.0134 84.6634 64.4318C85.1119 64.8542 85.4602 65.374 85.7082 65.9905C85.9562 66.61 86.059 67.3254 86.0166 68.134L85.2779 82.112C85.2355 82.9086 85.0573 83.597 84.7433 84.1752C84.4293 84.7496 84.0245 85.2185 83.5289 85.5816C83.0333 85.9406 82.4702 86.1818 81.8396 86.3061C81.2091 86.428 80.5566 86.4322 79.8823 86.3208C79.2079 86.2098 78.5678 85.9955 77.962 85.6799C77.3562 85.3673 76.829 84.9728 76.3805 84.4969C75.932 84.0251 75.5838 83.4905 75.3357 82.8923C75.0877 82.2971 74.9849 81.6421 75.0274 80.9243L75.766 68.3181ZM78.4674 81.3112C78.4414 81.7661 78.5773 82.1626 78.8749 82.5023C79.1725 82.844 79.5686 83.0481 80.0632 83.1134C80.5577 83.1789 80.9709 83.079 81.3027 82.812C81.6345 82.5431 81.8133 82.1727 81.8392 81.7019L82.5779 68.1842C82.6038 67.7063 82.468 67.3136 82.1703 67.0078C81.8727 66.7038 81.4766 66.5609 80.9821 66.5778C80.4875 66.5949 80.0744 66.7627 79.7426 67.0797C79.4108 67.3948 79.2319 67.7827 79.206 68.2448L78.4674 81.3112Z",
    fill: "url(#paint8_linear_2622_35519)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.671 17.5312L117.814 36.014V106.614L172.057 85.0616L172.671 17.5312Z",
    fill: "#D2DEE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.671 17.5312L117.814 36.014V106.614L172.057 85.0616L172.671 17.5312Z",
    fill: "url(#paint9_linear_2622_35519)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.444 17.4844L191.622 44.2207L136.106 66.1349L117.666 35.5458L172.444 17.4844Z",
    fill: "#E0E0E1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.352 62.4422L123.104 65.5075L122.661 67.683L122.821 69.553L123.221 72.3657L122.75 97.8039L123.303 89.8915L124.335 89.2083L123.593 85.7453L123.727 72.401L123.596 69.0419L124.05 67.7801L123.698 65.5491L123.746 56.3288L123.352 62.4422Z",
    fill: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.449 84.7909L127.272 81.3517L127.514 68.6739L127.034 72.5818L126.656 71.3067L126.783 74.6295L126.768 81.2899L126.488 83.5721L126.858 84.7183L126.893 89.3242L127.449 84.7909Z",
    fill: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.516 92.3338L129.787 89.5499L129.533 87.5521L129.658 85.8571L129.947 83.3144L129.967 60.1477L130.219 67.3704L130.25 69.701L130.351 71.1552L130.269 83.3031L130.33 86.2652L130.416 87.5213L130.165 89.5367L130.079 97.9286L129.516 92.3338Z",
    fill: "#B2B4B6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2792 18.7617L28.1821 46.6889L98.129 65.419L118.427 35.4032L46.2792 18.7617Z",
    fill: "#E0E0E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2622_35519",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 18,
    width: 91,
    height: 48
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2792 18.7617L28.1821 46.6889L98.129 65.419L118.427 35.4032L46.2792 18.7617Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2622_35519)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1488 40.1664L65.9835 37.6983L67.5116 36.088L68.3671 34.4174L69.5182 31.8201L83.3983 10.4971L78.7362 16.914L77.4991 16.9467L76.2932 20.2766L69.1079 31.522L67.4389 34.4401L66.3851 35.2695L65.5017 37.3483L60.5752 45.1422L64.1488 40.1664Z",
    fill: "#C2C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.519 19.0378L70.8471 22.0486L63.923 32.6713L66.4008 29.6115L66.0464 30.8935L67.6992 28.0081L71.2412 22.3677L72.6883 20.5808L72.9817 19.4125L75.3933 15.4883L72.519 19.0378Z",
    fill: "#C2C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7633 11.5468L73.0583 13.764L72.2149 15.5928L71.2107 16.9641L69.6177 18.967L57.3246 38.603L60.9382 32.3442L62.1474 30.3515L62.8317 29.0644L69.3388 18.8059L70.857 16.2618L71.4492 15.1507L72.7308 13.5749L77.2501 6.5035L74.7633 11.5468Z",
    fill: "#C2C3C4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2622_35519",
    x: 67.4207,
    y: 2.20312,
    width: 100.171,
    height: 93.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469255 0 0 0 0 0.264214 0 0 0 0 0.449378 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2622_35519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2622_35519",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2622_35519",
    x1: 164.822,
    y1: 147.278,
    x2: 132.182,
    y2: 89.0363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0907175,
    stopColor: "#ABABAB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2622_35519",
    x1: 97.7816,
    y1: 4.20421,
    x2: 107.282,
    y2: 22.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2622_35519",
    x1: 137.08,
    y1: 4.20421,
    x2: 127.58,
    y2: 22.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2622_35519",
    x1: 117.673,
    y1: 12.7422,
    x2: 117.673,
    y2: 50.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2622_35519",
    x1: 116.719,
    y1: 10.1055,
    x2: 116.719,
    y2: 15.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2622_35519",
    x1: 81.9536,
    y1: 19.375,
    x2: 81.9536,
    y2: 106.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2622_35519",
    x1: 57.7863,
    y1: 59.51,
    x2: 54.3343,
    y2: 78.3228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2622_35519",
    x1: 91.5512,
    y1: 68.5988,
    x2: 88.0426,
    y2: 87.5601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2622_35519",
    x1: 75.7002,
    y1: 63.0914,
    x2: 69.7914,
    y2: 81.5978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2622_35519",
    x1: 145.242,
    y1: 17.5312,
    x2: 145.242,
    y2: 106.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_35519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 145.93,
    fill: "white",
    transform: "translate(0 0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.f28597ad213ade22a7da7d7d071374e5.svg";
export { ForwardRef as ReactComponent };